import 'slick-carousel';

const $slider = $('.dunn-slider');
const $slideCount = $('.dunn-slide-count');

const $beachesSlider = $('.runaway-slider');
const $beachesSlideCount = $('.runaway-slide-count');

// $slider.on('init', () => {
//     $slider.parent().css({ 'visibility': 'visible' });
// });

// Rivers Dunn Slider

$slider.slick({
  dots: false,
  arrows: true,
  // lazyLoad: 'progressive',
  prevArrow: $('.dunn-slider-container .left-arrow-container'),
  nextArrow: $('.dunn-slider-container .right-arrow-container'),
  variableWidth: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        variableWidth: true
      }
    }
  ]
});

$slider.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1 + '/' + slick.slideCount;

  $slideCount.find('span').text(i);
});

// Beaches Runaway Slider
$beachesSlider.slick({
  dots: false,
  arrows: true,
  // lazyLoad: 'progressive',
  prevArrow: $('.runaway-slider-container .left-arrow-container'),
  nextArrow: $('.runaway-slider-container .right-arrow-container'),
  variableWidth: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        variableWidth: true
      }
    }
  ]
});

$beachesSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1 + '/' + slick.slideCount;

  $beachesSlideCount.find('span').text(i);
});

// Experiences Slider
$('.experiences-card-slider').slick({
  variableWidth: true,
  prevArrow: '.experiences-slider-nav .icon-button-arrow-prev',
  nextArrow: '.experiences-slider-nav .icon-button-arrow-next',
  mobileFirst: true,
  lazyLoad: 'progressive',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
      },
    },
  ],
});
